$(function () {
    $(document).on('change', '#js-advanced-settings', function(){
        switchAdvancedSettings();
    });

    function switchAdvancedSettings() {
        if ($('#js-advanced-settings').prop('checked')) {
            $('.advanced-settings').fadeIn();
        } else {
            $('.advanced-settings').fadeOut();
        }
    }
    switchAdvancedSettings();

    // ------------------------------
    // 並び替え
    // ------------------------------
    /**
     * Sortable設定
     * @param object (Element object) 並び替え範囲のオブジェクト
     */
    function setSortable(target) {
        Sortable.create(target, {
        animation: 100,
        handle:'.handle',
        onEnd: function (e) {
            $(target).children('.nested-fields').each(function (i, el) {
            $(el).find('.order').val(i+1);
            });
        }
        })
    }
    
    function setSortableRequiredItems(target) {
        Sortable.create(target, {
        animation: 100,
        handle:'.handle',
        onEnd: function (e) {
            $(target).children('.card').each(function (i, el) {
            $(el).find('.order').val(i+1);
            });
        }
        })
    }

    /**
     * 各要素に順番を設定
     */

    function setOrder($target) {
        $target.children('.nested-fields').each(function (i, el) {
            $(el).find('.order').val(i+1);
        });
    }

    function setOrderRequiredItems($target) {
        $target.children('.card').each(function (i, el) {
            $(el).find('.order').val(i+1);
        });
    }

    // コマ単位情報
    let $staffItemFields = $('.js-hospital_staff_item_field');
    $staffItemFields.each(function (i, staffItemFields) {
        if (staffItemFields) {
            // 初期設定
            setSortable(staffItemFields);
            // 追加時の監視
            let staffItemObserver = new MutationObserver( () => {
            setOrder($(staffItemFields))
            });
            staffItemObserver.observe(staffItemFields, {childList: true, subtree: true});
        }
    })

    // 選択肢1フィールド
    let $requiredItemFields = $('.js-hospital_required_item_field');
    $requiredItemFields.each(function (i, requiredItemField) {
        if (requiredItemField) {
            // 初期設定
            setSortableRequiredItems(requiredItemField);
            // 追加時の監視
            let requiredItemObserver = new MutationObserver( () => {
            setOrderRequiredItems($(requiredItemField))
            });
            requiredItemObserver.observe(requiredItemField, {childList: true, subtree: true});
        }
    })

    // 選択肢2フィールド
    let $optionalItemFields = $('.js-hospital_optional_item_field');
    $optionalItemFields.each(function (i, optionalItemField) {
        if (optionalItemField) {
            // 初期設定
            setSortable(optionalItemField);
            // 追加時の監視
            let optionalItemObserver = new MutationObserver( () => {
            setOrder($(optionalItemField))
            });
            optionalItemObserver.observe(optionalItemField, {childList: true, subtree: true});
        }
    })

});
